/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { OasContact } from '../../models/OasContact';

/**
 * Constructor.
 * @class
 * @extends OasContact
 * @author eric.wittmann@gmail.com
 */
export class Oas30Contact extends OasContact {
    public constructor() {
        super();
    }
}
Oas30Contact["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Contact";
Oas30Contact["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




